import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import CloseIcon from '@mui/icons-material/Close';

import {
  entity,
  entityBillingPaymentMethods,
  entityHelp,
  entitySubscriptions
} from '#client/constants/routes';

export { ChevronLeftRoundedIcon, CloseIcon };

/**
 * Navigation targets for the restart flow, resolved from route templates in `constants/routes`.
 * @param {string} businessEntityUuid
 * @returns {{ dashboard: string, help: string, paymentMethods: string, subscriptions: string }}
 */
export function getSubscriptionRestartPaths(businessEntityUuid) {
  if (!businessEntityUuid) {
    return {
      dashboard: '',
      help: '',
      paymentMethods: '',
      subscriptions: ''
    };
  }

  return {
    dashboard: entity.replace(':businessEntityUuid', businessEntityUuid),
    help: entityHelp.replace(':businessEntityUuid', businessEntityUuid),
    paymentMethods: entityBillingPaymentMethods.replace(':businessEntityUuid', businessEntityUuid),
    subscriptions: entitySubscriptions.replace(':businessEntityUuid', businessEntityUuid)
  };
}
